import { Link, useLocation } from "react-router-dom";

const ITEMS = [
  { label: "首页", icon: "ri-home-5-line", active: "ri-home-5-fill", to: "/", match: "/" },
  { label: "分类", icon: "ri-function-line", active: "ri-function-fill", to: "/category", match: "/category" },
  { label: "搜索", icon: "ri-search-line", active: "ri-search-line", to: "/search", match: "/search" },
  { label: "收藏", icon: "ri-heart-line", active: "ri-heart-fill", to: "/category?fav=1", match: "fav" },
  { label: "我的", icon: "ri-user-3-line", active: "ri-user-3-fill", to: "/about", match: "/about" },
];

export default function MobileBottomNav() {
  const location = useLocation();

  const isActive = (item: (typeof ITEMS)[number]) => {
    if (item.match === "/") return location.pathname === "/";
    if (item.match === "fav") {
      return (
        location.pathname === "/category" &&
        new URLSearchParams(location.search).get("fav") === "1"
      );
    }
    if (item.match === "/category") {
      return (
        location.pathname === "/category" &&
        new URLSearchParams(location.search).get("fav") !== "1"
      );
    }
    return location.pathname.startsWith(item.match);
  };

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-background-50/95 backdrop-blur border-t border-background-200">
      <div className="grid grid-cols-5">
        {ITEMS.map((item) => {
          const active = isActive(item);
          return (
            <Link
              key={item.label}
              to={item.to}
              className={`flex flex-col items-center justify-center gap-0.5 py-2.5 cursor-pointer ${
                active ? "text-primary-600" : "text-foreground-500"
              }`}
            >
              <i className={`${active ? item.active : item.icon} text-lg`}></i>
              <span className="text-[11px]">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}